export type JobsTrafficSplitDestination = 'employers-home' | 'your-jobs';
export type JobsLinkDestination = 'employers' | 'madgex';

export interface JobsTrafficSplitResult {
    url: string;
    linkDestination: JobsLinkDestination;
}

interface JobsTrafficSplitInput {
    buyerUrl?: string;
    eligible: boolean;
    fallbackUrl: string;
    destination?: JobsTrafficSplitDestination;
}

export function getJobsTrafficSplitResult({
    buyerUrl,
    eligible,
    fallbackUrl,
    destination = 'employers-home',
}: JobsTrafficSplitInput): JobsTrafficSplitResult {
    if (!eligible || !buyerUrl) {
        return { url: fallbackUrl, linkDestination: 'madgex' };
    }

    const employersUrl = `${buyerUrl.replace(/\/$/, '')}/employers/`;
    return {
        url: destination === 'your-jobs' ? `${employersUrl}your-jobs` : employersUrl,
        linkDestination: 'employers',
    };
}

export function getJobsTrafficSplitUrl(input: JobsTrafficSplitInput): string {
    return getJobsTrafficSplitResult(input).url;
}
